import type { ReactNode } from 'react'

import { Add } from '@mui/icons-material'
import { Button, Stack, Tooltip, Typography } from '@mui/material'

interface Props {
  fieldLabel: ReactNode
  testId?: string
  action: {
    disabled?: boolean
    onClick: () => void
    label: string
    tooltip: string
  }
}

export function FieldHeader(props: Props) {
  const {
    fieldLabel,
    testId,
    action: { disabled, onClick, label, tooltip },
  } = props

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      height={31}
      data-testid={testId}
    >
      <Typography noWrap variant="body1">
        {fieldLabel}
      </Typography>
      <Tooltip title={tooltip}>
        <span>
          <Button
            onClick={onClick}
            disabled={disabled}
            data-testid={`${testId}-button`}
            data-trackid={`${testId}-button`}
            variant="outlined"
            size="small"
          >
            <Add /> {label}
          </Button>
        </span>
      </Tooltip>
    </Stack>
  )
}
